import { jsxs as g, jsx as u } from "react/jsx-runtime";
import { c as h } from "../index-rKuIKazb.js";
import _ from "../ImgHeroAchievable/index.js";
import '../assets/index14.css';const B = "_layout_1i85m_2", k = "_hideBackground_1i85m_7", b = "_hideBackgroundMobile_1i85m_12", M = "_image_1i85m_15", e = {
  layout: B,
  hideBackground: k,
  hideBackgroundMobile: b,
  image: M
}, y = {
  achievable: _
}, v = (o) => {
  const {
    children: i,
    className: c,
    fixed: s,
    hideBackground: d,
    hideBackgroundMobile: n,
    reverse: r,
    size: t,
    theme: m,
    type: a = "achievable"
  } = o, l = y[a];
  return /* @__PURE__ */ g("div", { className: e.layout, children: [
    /* @__PURE__ */ u(
      l,
      {
        className: h(
          e.image,
          e[a],
          d && e.hideBackground,
          n && e.hideBackgroundMobile,
          c
        ),
        fixed: s,
        reverse: r,
        size: t,
        theme: m
      }
    ),
    i
  ] });
};
export {
  v as default
};
